export default __webpack_public_path__ + "static/media/numbersearch_standard.d2a5ee25.svg";